/* Glow2ball muis-parallax — vanilla JS, geen dependencies.
   Normaliseert de muispositie naar -1..1 t.o.v. het sectiemidden en zet per
   afbeelding --parallax-x/--parallax-y (px), met rAF + lerp voor het na-ijlen. */
function initG2bParallax() {
  document.querySelectorAll('[data-g2b-parallax]').forEach(function (section) {
    if (section.dataset.g2bParallaxInit === 'true') return;
    section.dataset.g2bParallaxInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var items = Array.from(section.querySelectorAll('[data-parallax-strength]'));
    if (!items.length) return;

    var targetX = 0, targetY = 0, currentX = 0, currentY = 0, raf = null;
    var EASE = 0.08;

    function lerp(a, b, t) { return a + (b - a) * t; }

    function frame() {
      currentX = lerp(currentX, targetX, EASE);
      currentY = lerp(currentY, targetY, EASE);

      items.forEach(function (el) {
        var strength = parseFloat(el.dataset.parallaxStrength) || 0;
        var dir = el.dataset.parallaxInvert === 'true' ? -1 : 1;
        el.style.setProperty('--parallax-x', (currentX * strength * dir).toFixed(2) + 'px');
        el.style.setProperty('--parallax-y', (currentY * strength * dir).toFixed(2) + 'px');
      });

      if (Math.abs(currentX - targetX) > 0.001 || Math.abs(currentY - targetY) > 0.001) {
        raf = requestAnimationFrame(frame);
      } else {
        raf = null;
      }
    }

    function start() {
      if (raf === null) raf = requestAnimationFrame(frame);
    }

    section.addEventListener('mousemove', function (event) {
      /* getBoundingClientRect is viewport-relatief en dus onafhankelijk van
         welke wrapper er scrollt. */
      var rect = section.getBoundingClientRect();
      targetX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      targetY = ((event.clientY - rect.top) / rect.height) * 2 - 1;
      start();
    });

    section.addEventListener('mouseleave', function () {
      targetX = 0;
      targetY = 0;
      start();
    });
  });
}

document.addEventListener('DOMContentLoaded', initG2bParallax);
document.addEventListener('shopify:section:load', initG2bParallax);
